var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAviator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9509 15.3643L13.9598 15.3029L16.4618 5.53978C16.6463 4.72329 17.0326 4.04713 17.6207 3.52021C18.2093 2.99389 18.8762 2.73013 19.6049 2.73013C20.29 2.73013 20.7902 2.95858 21.124 3.42379C21.4488 3.88039 21.5628 4.46843 21.4488 5.17129L21.3874 5.53978L18.8851 15.3029L18.8676 15.3643H13.9509ZM25.3381 1.54486C24.0914 0.517722 22.4146 0 20.2986 0C17.9897 0 15.9616 0.579433 14.1969 1.7297C12.4322 2.87966 11.3169 4.40731 10.8428 6.31235L8.57757 15.3029C6.66363 15.3029 4.89003 15.3115 3.51161 15.3115C1.56296 15.3115 0 16.9009 0 18.8501H7.68217L4.88142 30H10.2898L13.0994 18.8501H18.0247L16.2775 25.7683C16.225 25.9001 16.1897 26.0757 16.1547 26.2952C15.9616 27.463 16.1897 28.3756 16.8481 29.0257C17.4978 29.6751 18.49 30 19.8156 30H21.9758L22.6691 27.2696C21.8876 27.2171 21.5628 26.7955 21.6948 26.014L26.6376 6.31235C26.6462 6.25124 26.664 6.14562 26.7079 5.98748C26.7519 5.82074 26.7694 5.71512 26.778 5.654C27.0589 3.95071 26.5759 2.5809 25.3381 1.54486Z",
    fill: "#ec171f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviator);
export default __webpack_public_path__ + "static/media/aviator.5aedbf505b856e52592ce0e46487fea7.svg";
export { ForwardRef as ReactComponent };